export enum CandidateStatus {
  Onboarding = 'onboarding',
  FollowUp = 'follow_up',
  NoPhoneNumber = 'no_phone',
  SendReminder = 'send_reminder',
  ReachedNoDocuments = 'reached_no_documents',
  SendToGrowth = 'send_to_growth',
  Cem = 'cem',
  OnHold = 'on_hold',
  Disqualified = 'disqualified',
  Hired = 'hired',
  Blacklist = 'blacklist',
  InterestedButNoJobs = 'interested_but_no_jobs',
  NewJobs = 'new_jobs',
}

export const CANDIDATE_STATUS_I18N = {
  [CandidateStatus.Cem]: 'CEM',
  [CandidateStatus.Disqualified]: 'Disqualified',
  [CandidateStatus.FollowUp]: 'Follow up',
  [CandidateStatus.Hired]: 'Hired',
  [CandidateStatus.NoPhoneNumber]: 'No phone',
  [CandidateStatus.OnHold]: 'On hold',
  [CandidateStatus.Onboarding]: 'Onboarding',
  [CandidateStatus.ReachedNoDocuments]: 'Reached no documents',
  [CandidateStatus.SendReminder]: 'Send reminder',
  [CandidateStatus.SendToGrowth]: 'Send to growth',
  [CandidateStatus.Blacklist]: 'Blacklist',
  [CandidateStatus.InterestedButNoJobs]: 'Interested but no jobs',
  [CandidateStatus.NewJobs]: 'New jobs',
};
